module.exports = __webpack_public_path__ + "img/6.b6b08c31.jpg";